/**
 * Created by Ning Jiang on 2021-06-23.
 */

import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {ReelState} from "../../core/reel/ReelState";
import {DDay} from "../DDay";
import {BelowStakeWinRestriction} from "../server/BelowStakeWinRestriction";
import {BlitzKriegGameMode} from "../server/BlitzKriegGameMode";
import {DDayLayers, Layers} from "../view/DDayLayers";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {BlitzKriegSound} from "../sound/BlitzKriegSound";

export class BlitzKriegNormalIdlePresentation implements FlowStatePresentation {
    private isFirstTimePresentation: boolean = true;

    constructor() {
    }

    public async start(flowStateController: FlowStateController) {
        flowStateController.setSkipCallback(() => {
        });
        const isIntroSplashEnable: boolean = this.isFirstTimePresentation && !DDay.model.parsedInitData.isRestoreState && !DDay.apiPlugin.isReplay && !DDay.apiPlugin.freeBets.hasFreeBets();
        DDay.reels.forEach((reel) => {
            reel.reelState = ReelState.IDLE;
            if (isIntroSplashEnable) {
                reel.reelView.disableEnableReelsArea();
            }
        });
        // To fix freebet issue where we have to skip intro and enable all background assets
        if (this.isFirstTimePresentation && !DDay.model.parsedInitData.isRestoreState && DDay.apiPlugin.freeBets.hasFreeBets()) {
            DDay.reelBackground.enableLogo(true);
            DDay.reelBackground.enableRadioAndWaysFrame();
            DDay.reelBackground.setXWaysCount(720);
            let layer: StageLayer | undefined = DDayLayers.getLayer(Layers.LOW_SYMBOLS);
            if (layer) {
                DDay.commonService.applyMaskOnReel(layer)
            }
        }
        if (isIntroSplashEnable) {
            BlitzKriegSound.setCurrentMusicName(BlitzKriegSound.MAIN_GAME_MUSIC);
            BlitzKriegSound.fadeMusic(0, 0);
            let spinButton = DDay.apiPlugin.settings.get(APISetting.USE_SPACE_TO_SPIN, false);
            DDay.apiPlugin.settings.set(APISetting.USE_SPACE_TO_SPIN, false);
            await DDay.introSplash.animateBackground().then(() => {
                BlitzKriegSound.fadeMusic(1, 0);
                DDay.reelBackground.disableXWaysCount(false);
                let layer: StageLayer | undefined = DDayLayers.getLayer(Layers.LOW_SYMBOLS);
                if (layer) {
                    DDay.commonService.applyMaskOnReel(layer)
                }
                DDay.apiPlugin.settings.set(APISetting.USE_SPACE_TO_SPIN, spinButton);
                flowStateController.finish();
                DDay.reelBackground.playStopStaticCharge(false).play();
            });
        } else {
            flowStateController.setSkipCallback(() => this.skip(flowStateController));
            if (DDay.apiPlugin.isReplay) {
                let layer: StageLayer | undefined = DDayLayers.getLayer(Layers.LOW_SYMBOLS);
                if (layer) {
                    DDay.commonService.applyMaskOnReel(layer)
                }
            }
            if (DDay.model.gameData?.nextMode != GameMode.NORMAL) {
                this.isFirstTimePresentation = false;
                flowStateController.finish();
                return;
            }



            //Because the tombstonerip has Gamble enabled, you wont see any win toggeling. It was decided during BookOfShadow that no toggeling should happen if there was gamble involved.
            //Though if you play the game with Norsktipping or Germany jurisdiction it will function as normal because at the moment ow writing this Gamble is not allowed in those jurisdictions.
            if (!BelowStakeWinRestriction.isWinBelowStake() && !DDay.autoPlayPlugin.isAutoplayRound &&
                !DDay.model.gameData.brokeTheBank && DDay.model.gameData.nextMode === BlitzKriegGameMode.NORMAL) {
                DDay.individualWin.start();
            }
        }
        if (!DDay.autoPlayPlugin.isAutoplayRound && !DDay.apiPlugin.isReplay && !(DDay.model.parsedGameData && DDay.model.parsedGameData.betWins.length > 0)) {
            DDay.reelBackground.enableKnobClick();
        }
        this.isFirstTimePresentation = false;
    }

    private async skip(flowStateController: FlowStateController): Promise<any> {
        await DDay.individualWin.stop();
        flowStateController.finish();
    }
}
